























































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import OrderApi from '@/api/order/list'
import printJS from 'print-js'

@Component({
  components: {}
})
export default class PrintOrder extends AbpBase {
  invoiceList: any[] = []

  @Watch('$route', {
    immediate: true
  })
  routeWatch() {
    const { ids } = this.$route.params
    console.log(decodeURIComponent(ids).split(','))
    this.getOrderList(decodeURIComponent(ids).split(','))
  }

  getOrderList(ids: any[]) {
    OrderApi.getPrintList(ids)
      .then(res => {
        this.invoiceList = res.data.items
      })
      .catch(err => {
        this.invoiceList = []
      })
  }
  handlePrint() {
    printJS({
      printable: 'printJS-form',
      type: 'html',
      maxWidth: 1200,
      scanStyles: false,
      style:
        '@page {size:landscape;margin: 0;}p{margin:0;padding:0;}.order-invoice-list .order-invoice:not(:first-child){margin-top:20px}.order-invoice-list .order-invoice{background:#f2f2f2;padding-bottom:20px;page-break-after: always;}.order-invoice-list .order-invoice-title{text-align:center;padding:20px 0}.order-invoice-list .order-invoice .table{width:100%;border-collapse:collapse}.order-invoice-list .order-invoice .table thead{background-color:#f8f8f9}.order-invoice-list .order-invoice .table tbody{background-color:#fff}.order-invoice-list .order-invoice .table tfoot{text-align:right}.order-invoice-list .order-invoice .table tfoot tr td{text-align:right}.order-invoice-list .order-invoice .table td,.order-invoice-list .order-invoice .table th{border:1px solid #ddd;padding:8px;text-align:center}.order-invoice-list .order-invoice .user-info{margin-top:10px;background:#f2f2f2}.order-invoice-list .order-invoice .user-info-table{width:100%}.order-invoice-list .order-invoice .user-info-table .key{width:10%;text-align:right;font-weight:bold;white-space: nowrap;}.order-invoice-list .order-invoice .user-info-table .value{text-align:left;word-break: break-all;}.order-invoice-list .order-invoice .user-info-table .width-15{width:15%}.order-invoice-list .order-invoice .user-info-table .width-25{width:30%}.order-invoice-list .order-invoice .user-info-table .barcode{width:35%;text-align:right}.order-invoice-list .order-invoice .user-info-table .barcode img{margin-right:10px}'
    })
  }
}
